import React, { Suspense, lazy } from 'react';
import { FeedbackButton } from '../../common/feedback-collector/feedback-button';

const AsyncFeedbackCollector = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/feedback-collector" */ './feedback-collector'
		),
);

const ExtensibleFeedbackCollector = () => {
	return (
		<Suspense fallback={<FeedbackButton onClick={() => {}} />}>
			<AsyncFeedbackCollector />
		</Suspense>
	);
};

export default ExtensibleFeedbackCollector;
